import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that automatically scrolls to the top 
 * of the page when navigating between routes.
 * 
 * This component should be placed inside the Router component
 * but outside of Routes to work properly.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    if (pathname !== prevPathRef.current) {
      window.scrollTo(0, 0);
      prevPathRef.current = pathname;
    }
  }, [pathname]);

  return null; // Este componente no renderiza nada
};

export default ScrollToTop; 